import React from "react";
import "./App.css";
import EmailRenderer from "./components/EmailRenderer";

const App = () => {
  return (
    <div className="App">
      <EmailRenderer />
    </div>
  );
};

export default App;
